<template>
  <div class="page">
    <h1 class="mt-0 mb-3">Скачать приложение</h1>

    <div>
      <div v-for="(appVersion, ind) in filteredAppVersions" :key="ind" class="mb-2">
        <a :href="appVersion.url" download="" class="text-secondary">
          <template v-if="ind === 0">
            Скачать последнюю версию {{appVersion.version}} от {{$moment.utc(appVersion.date).format('DD.MM.YYYY')}}
          </template>
          <template v-else>
            Скачать предыдущую версию {{appVersion.version}} от {{$moment.utc(appVersion.date).format('DD.MM.YYYY')}}
          </template>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

const APP_VERSION_TYPE = {
  STABLE: 'STABLE',
  REGULAR: 'REGULAR',
};

export default {
  computed: {
    ...mapGetters({
      appVersions: 'appVersions/items',
      appVersionsFetchProgress: 'appVersions/fetchProgress',
    }),
    filteredAppVersions() {
      const appArr = [];
      const [lastApp] = this.appVersions;
      if (lastApp) {
        appArr.push(lastApp);
      }
      const prevApp = this.appVersions.find((x) => x.type.toUpperCase() === APP_VERSION_TYPE.STABLE);
      if (prevApp) {
        appArr.push(prevApp);
      }
      return appArr;
    },
  },

  methods: {
    ...mapActions({
      fetchAppVersions: 'appVersions/fetchItems',
    }),
  },

  created() {
    this.fetchAppVersions();
  },
};
</script>
